interface GenericList {
  name: string;
  value: string;
}

export const RegistryList: GenericList[] = [
  {
    name: 'Verra',
    value: 'Verra',
  },
  {
    name: 'Gold Standard',
    value: 'Gold',
  },
];

export const ProjectTypeList: Record<string, GenericList[]> = {
  Verra: [
    {
      name: 'Afforestation, Reforestation, and Revegetation',
      value: 'ARR',
    },
    { name: 'Improved Forest Management', value: 'IFM' },
    { name: 'Agricultural Land Management', value: 'ALM' },
    {
      name: 'Avoided Conversion of Grasslands and Shrublands',
      value: 'ACGS',
    },
    {
      name: 'Tidal Wetlands and Seagrass Restoration',
      value: 'TWSR',
    },
    { name: 'Peatland Rewetting and Conservation', value: 'PRC' },
  ],
  Gold: [
    {
      name: 'Afforestation, Reforestation, and Revegetation',
      value: 'ARR',
    },
    {
      name: 'Sustainable Management of mangroves',
      value: 'SMM',
    },
    {
      name: 'Water and erosion impact assessment of sustainable agricultural land management',
      value: 'WE',
    },
  ],
};
